import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '100%',
    minWidth: '550px',
    height: '100% ',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    backgroundColor: Colors.lightGray,
    padding: '1.25rem',
    borderRadius: 5,
    border: `1px solid ${Colors.gray}`,
    gap: '1rem',
    textAlign: 'justify',
  },

  formWrapper: {
    width: '100%',
    backgroundColor: Colors.white,
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem',
  },

  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '1rem 0 0',
    gap: '1rem',
  },

  questionConfirmation: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    fontSize: '1.5rem',

    '& > p > span': {
      fontWeight: 600,
    },
    '& > p:last-child': {
      fontStyle: 'italic',
      marginTop: '0.5rem',
      fontSize: '1.5rem',
      border: `1px solid ${Colors.mediumLightGray}`,
      borderRadius: 3,
      padding: '1rem',
    },
  },

  questionText: {
    padding: '0 0 2rem 0',
    wordWrap: 'break-word',
    fontSize: '1.5rem',
    fontStyle: 'italic',
    '& > span':{
      fontWeight: 600,
      fontSize: '1.5rem',

    },
  },
  
  inputRoot: {
    fontSize: 10,
  },
  
}))

export default styles
